var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 11.75L11.7493 8.99996M11.7493 8.99996L8.99935 6.24996M11.7493 8.99996H1.66602M6.24935 4.6445V4.60014C6.24935 3.57337 6.24935 3.05961 6.44917 2.66744C6.62494 2.32248 6.9052 2.04222 7.25016 1.86645C7.64233 1.66663 8.1561 1.66663 9.18286 1.66663H13.3995C14.4263 1.66663 14.939 1.66663 15.3311 1.86645C15.6761 2.04222 15.9573 2.32248 16.1331 2.66744C16.3327 3.05923 16.3327 3.57237 16.3327 4.59713V13.4032C16.3327 14.428 16.3327 14.9404 16.1331 15.3322C15.9573 15.6771 15.6761 15.9579 15.3311 16.1337C14.9393 16.3333 14.4269 16.3333 13.4022 16.3333H9.17985C8.15509 16.3333 7.64195 16.3333 7.25016 16.1337C6.9052 15.9579 6.62494 15.6769 6.44917 15.3319C6.24935 14.9397 6.24935 14.4267 6.24935 13.4V13.3541",
    stroke: "#0075FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.2e0b7c9fc55bb03d4dec9c5fa9d0f263.svg";
export { ForwardRef as ReactComponent };